<template>
  <div class="content-box">
    <el-form class="productShortNameForm clearfix" :inline="true" :model="form" ref="ruleForm">
      <el-form-item label="操作日期">
        <yto-date-picker
          :maxRangeVal="31"
          :picker-options="pickerOptions1"
          value-format="yyyy-MM-dd HH:mm:ss"
          v-model="createTime"
          type="datetimerange"
          :default-time="['00:00:00', '23:59:59']"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          :clearable="false"
          size="mini"
          :editable="false"
        ></yto-date-picker>
      </el-form-item>
      <el-form-item label="操作人姓名">
        <el-input size="mini" class="y-w-160" v-model.trim="form.inviteName" placeholder="请输入操作人姓名"></el-input>
      </el-form-item>
      <el-form-item label="操作人手机号">
        <el-input size="mini" class="y-w-160" v-model.trim="form.inviteTel" placeholder="请输入操作人手机号"></el-input>
      </el-form-item>
      <el-form-item label="操作端">
        <el-select size="mini" class="y-w-160" v-model="form.channel">
          <el-option label="全部" value=""></el-option>
          <el-option label="PC" value="PC"></el-option>
          <el-option label="APP" value="APP"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="被操作人姓名">
        <el-input size="mini" class="y-w-160" v-model.trim="form.memberName" placeholder="请输入被操作人姓名"></el-input>
      </el-form-item>
      <el-form-item label="被操作人手机号">
        <el-input size="mini" class="y-w-160" v-model.trim="form.memberTel" placeholder="请输入被操作人手机号"></el-input>
      </el-form-item>
      <el-form-item label="专属客服群名称">
        <el-input size="mini" class="y-w-160" v-model.trim="form.groupName" placeholder="请输入专属客服群名称"></el-input>
      </el-form-item>
      <el-form-item label="状态">
        <el-select size="mini" class="y-w-160" v-model="form.status">
          <el-option label="全部" value=""></el-option>
          <el-option label="成功" value="0"></el-option>
          <el-option label="失败" value="-1"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item class="y-f-r">
        <el-button icon="el-icon-search" type="primary" @click="search" size="mini">查询</el-button>
        <el-button icon="el-icon-refresh-left" class="normal-btn" @click="resetForm" size="mini">重置</el-button>
        <el-button icon="el-icon-download" class="normal-btn" @click="exportData" size="mini">导出</el-button>
      </el-form-item>
    </el-form>
    <div class="y-h-10 y-bk-F0F2F8"></div>
    <div class="yto-table y-pd-20">
      <el-table :data="tableData" v-loading="loading">
        <el-table-column type="index" align="center" label="序号" width="70px"></el-table-column>
        <el-table-column align="center" prop="formatTime" label="操作日期"></el-table-column>
        <el-table-column align="center" prop="inviteName" label="操作人姓名"></el-table-column>
        <el-table-column align="center" prop="inviteTel" label="操作人手机号" width="120px">
          <template slot-scope="scope">
            <span v-show="!scope.row.inviteEncrypt">{{ scope.row.inviteTel }}</span>
            <span v-show="scope.row.inviteEncrypt">{{ scope.row.inviteTelEncrypt }}</span>
            <i class="y-fc-999 y-c-p" @click="handleEncryptInvite(scope.row)" :class="{'icomoon-no_view': !scope.row.inviteEncrypt, 'icomoon-view': scope.row.inviteEncrypt}"></i>
          </template>
        </el-table-column>
        <el-table-column align="center" label="操作端" width="70px" prop="channel"></el-table-column>
        <el-table-column align="center" prop="addType" label="操作类型"></el-table-column>
        <el-table-column align="center" prop="memberName" label="被操作人姓名"></el-table-column>
        <el-table-column align="center" prop="memberTel" label="被操作人手机号" width="110px">
          <template slot-scope="scope">
            <span v-show="!scope.row.memberEncrypt">{{ scope.row.memberTel }}</span>
            <span v-show="scope.row.memberEncrypt">{{ scope.row.memberTelEncrypt }}</span>
            <i class="y-fc-999 y-c-p" @click="handleEncryptMember(scope.row)" :class="{'icomoon-no_view': !scope.row.memberEncrypt, 'icomoon-view': scope.row.memberEncrypt}"></i>
          </template>
        </el-table-column>
        <el-table-column align="center" prop="groupName" label="专属客服群名称"></el-table-column>
        <el-table-column align="center" label="状态" width="70px">
          <template slot-scope="scope">
            <span class="y-fc-36C626" v-if="scope.row.status == '成功'">成功</span>
            <span class="y-fc-F35252" v-else>失败</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="原因" prop="message"></el-table-column>
      </el-table>
      <div class="fixed-paginton-footer box-shadow-wrapper">
        <el-pagination
          @size-change="limitChange"
          @current-change="queryList"
          :current-page.sync="pageNO"
          :page-sizes="[10, 50, 100]"
          :page-size="pageSize"
          :total="total"
          layout="total, sizes, prev, pager, next">
        </el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import { downloadFile, getYearMonthDay, dateFormat, YTOSHORTCUTSNo } from '@/utils/util.js';
import { exportOperationLogApi, getUserMobileByLoginIdApi, queryOperationLogApi } from "@/api/baseInfo/staffManage/operationLog"

export default {
  data() {
    return {
      tableData: [],
      pageNO: 1,
      pageSize: 50,
      total: 0,
      loading: false,
      form: {
        startTime: '', // 开始时间
        endTime: '', // 结束时间
        inviteName: '', // 操作人名称
        inviteTel: '', // 操作人手机号
        channel: '', // 操作端
        memberName: '', // 被操作人姓名
        memberTel: '', // 被操作人手机号
        groupName: '', // 专属客服群名称
        status: '', // 状态
      },
      pickerOptions1: {
        ...YTOSHORTCUTSNo,
        disabledDate(time) {
          let yesterday = new Date(new Date().getTime() - 179 * 24 * 3600000);
          return (
            time.getTime() > new Date((`${dateFormat(new Date(), 'yyyy-MM-dd')} 23:59:59`).split('-').join('/')).getTime() ||
            time.getTime() < new Date((`${dateFormat(yesterday, 'yyyy-MM-dd')} 00:00:00`).split('-').join('/')).getTime()
          );
        }
      },
      createTime: [],
    }
  },
  mounted() {
    this.resetForm();
  },
  computed: {
    userMess() {
      return this.$store.state.user;
    },
  },
  methods: {
    // 加解密操作人手机号
    handleEncryptInvite(row) {
      if(row.inviteEncrypt === undefined) {
        this.$set(row, 'inviteEncrypt', true);
        this.$set(row, 'inviteTelEncrypt', '--');
        let params = {
          loginId: row.inviteId
        }
        getUserMobileByLoginIdApi(params).then(res => {
          if(res.data) {
            row.inviteTelEncrypt = res.data
          }
        })
      } else {
        row.inviteEncrypt = !row.inviteEncrypt;
      }
    },
    // 加解密被操作人手机号
    handleEncryptMember(row) {
      if(row.memberEncrypt === undefined) {
        this.$set(row, 'memberEncrypt', true);
        this.$set(row, 'memberTelEncrypt', '--');
        let params = {
          loginId: row.memberId
        }
        getUserMobileByLoginIdApi(params).then(res => {
          if(res.data) {
            row.memberTelEncrypt = res.data
          }
        })
      } else {
        row.memberEncrypt = !row.memberEncrypt;
      }
    },
    // 每页条数变化
    limitChange(val) {
      this.pageNO = 1;
      this.pageSize = val;
      this.search();
    },
    exportData() {
      // 导出
      let params = {
        ...this.form,
        startTime: this.createTime[0],
        endTime: this.createTime[1],
        orgId: this.userMess.groupId,
      }
      exportOperationLogApi(params).then(res => {
        this.exportLoading = false;
        let blob = new Blob([res]);
        let dateobj = getYearMonthDay();
        let fileName = `客户管家操作日志${dateobj.yy}${dateobj.mm}${dateobj.dd}.xls`;
        downloadFile(blob, fileName);
      })
    },
    resetForm() {
      // 重置
      let createTime = [];
      createTime = [
        `${dateFormat(new Date(), 'yyyy-MM-dd')} 00:00:00`,
        `${dateFormat(new Date(), 'yyyy-MM-dd')} 23:59:59`
      ];
      this.createTime = createTime;
      this.form.startTime = createTime[0];
      this.form.endTime = createTime[1];
      this.form.inviteName = '';
      this.form.inviteTel = '';
      this.form.channel = '';
      this.form.memberName = '';
      this.form.memberTel = '';
      this.form.groupName = '';
      this.form.status = '';

      this.queryList();

    },
    search() {
      this.pageNO = 1;
      this.queryList();
    },
    queryList() {
      let params = {
        ...this.form,
        startTime: this.createTime[0],
        endTime: this.createTime[1],
        orgId: this.userMess.groupId,
        pageNO: this.pageNO,
        pageSize: this.pageSize
      }
      this.loading = true;
      queryOperationLogApi(params).then(res => {
        this.tableData = res.rows;
        this.total = res.total;
        this.loading = false;
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.productShortNameForm {
  padding: 20px 20px 0;
}
.content-box {
  height: calc(100vh - 100px);
  background: #fff;
}
.y-w-120 {
  width: 120px;  
}
</style>
